import { createAction } from '@wix/communities-blog-client-common';
import { type CommonThunkAction } from '@app/types/common-thunk-action.type';
import { createPromisifiedAction } from '../actions-promisifier/create-promisified-action';
import { appendAuthHeaders, getBlogApiBaseUrl } from '../controller/helpers';

export const submitPostForModerationSuccess = createAction(
  'post/SUBMIT_POST_FOR_MODERATION_SUCCESS',
  (payload, meta) => payload,
  (payload, meta) => meta,
);
const submitPostForModerationFailure = createAction('post/SUBMIT_POST_FOR_MODERATION_FAILURE');

const submitPostForModeration =
  (postId: string): CommonThunkAction<any> =>
  (dispatch, getState, { httpClient, errorHandler, platformApi }) => {
    const { withErrorHandler } = errorHandler;
    const promise = withErrorHandler(
      () =>
        httpClient.post(`${getBlogApiBaseUrl(platformApi)}/v3/moderation/${postId}`, undefined, {
          headers: appendAuthHeaders(platformApi),
        }),
      { errorCodesMap: {} },
    ).then((response) => response.data as { draftPost: unknown });

    return promise
      .then(({ draftPost }) => dispatch(submitPostForModerationSuccess({ draftPost }, undefined)))
      .catch((error) => dispatch(submitPostForModerationFailure(error)))
      .then(() => promise);
  };

export const submitPostForModerationPromisified = createPromisifiedAction(
  submitPostForModeration,
  (data) => data,
  (response) => response.status,
);
